import React from 'react';


const AkhuwatLoanInstruction = ()=>{
  return (
    <section className="container-fluid py-5">
      <div className="container">
        <h1 className="text-center mb-4 fw-bold">Stay Updated With Your Application Progress</h1>
        
        <p className="text-center mb-5">
        With Travel Embassy, you can instantly view your application details and records whenever you need them.
        </p>
        
        <h2 className="fw-bold mb-4">How to Check Your Status</h2>
        
        <ol className="fs-5">
          <li className="mb-2">Visit the official Travel Embassy website.</li>
          <li className="mb-2">Find and open the “Application Status Checker.”</li>
          <li className="mb-2">Hit Check Status to see:</li>
          <ul>
            <li>Current application stage</li>
            <li>Submitted documents</li>
            <li className="mb-2">Next required steps</li>
          </ul>
          <li className="mb-2">If you need help, our support team is just a message away and ready to guide you</li>
        </ol>
      </div>
    </section>
  );
}

export default AkhuwatLoanInstruction
